import React from 'react'
import {Icon} from '@chakra-ui/react'

const EmailIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M12.2656 2.98242C13.2689 2.98242 14.0829 3.79661 14.083 4.7998V11.2002C14.0827 12.2032 13.2687 13.0166 12.2656 13.0166H3.73242C2.72949 13.0164 1.91635 12.2031 1.91602 11.2002V4.7998C1.91616 3.79674 2.72937 2.98264 3.73242 2.98242H12.2656ZM3.41602 11.2002C3.41635 11.3747 3.55792 11.5164 3.73242 11.5166H12.2656C12.4403 11.5166 12.5827 11.3748 12.583 11.2002V6.69922L8.94043 9.01953C8.93179 9.02503 8.92292 9.03099 8.91406 9.03613C8.63702 9.19701 8.32231 9.28121 8.00195 9.28125C7.68151 9.28123 7.36597 9.19708 7.08887 9.03613C7.08035 9.03118 7.07179 9.02579 7.06348 9.02051L3.41602 6.69824V11.2002ZM3.73242 4.4834C3.5578 4.48361 3.41616 4.62517 3.41602 4.7998V4.9209L7.84766 7.74121C7.89476 7.76749 7.94796 7.78123 8.00195 7.78125C8.05576 7.78122 8.1083 7.76732 8.15527 7.74121L12.583 4.9209V4.7998C12.5829 4.62503 12.4404 4.4834 12.2656 4.4834H3.73242Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default EmailIcon
